import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Redirect, useLocation, Route, Switch } from "wouter";
import {
  Disclosure,
  Menu,
  MenuButton,
  MenuItems,
  MenuItem,
} from "@headlessui/react";
import AdminDashboard from "./AdminDashboard";
import AdminConversas from "./AdminConversas";

const Admin: React.FC = () => {
  const { user, logout } = useAuth();
  const [location] = useLocation();

  // Redireciona se não estiver autenticado
  if (!user) {
    return <Redirect to="/admin/login" />;
  }

  const handleLogout = () => {
    logout();
  };

  const userProfile = {
    name: user.name,
    email: user.email,
  };

  const navigation = [
    /* { name: "Dashboard", href: "/admin", current: location === "/admin" }, */
    {
      name: "Respostas GPT",
      href: "/admin/conversas",
      current: location === "/admin/conversas",
    },
    // Métricas da IA da central (senha própria, fora deste login).
    { name: "Métricas", href: "/admin/metricas", current: false },
  ];

  function classNames(...classes: string[]): string {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <div>
      <Disclosure as="nav" className="border-b border-gray-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 justify-between">
            <div className="flex">
              <div className="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
                {navigation.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    aria-current={item.current ? "page" : undefined}
                    className={classNames(
                      item.current
                        ? "border-indigo-500 text-gray-900"
                        : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700",
                      "inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium"
                    )}
                  >
                    {item.name}
                  </a>
                ))}
              </div>
            </div>
            <div className="hidden sm:ml-6 sm:flex sm:items-center">
              <Menu as="div" className="relative ml-3">
                <div>
                  <MenuButton className="relative flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-hidden">
                    <span className="absolute -inset-1.5" />
                    <span className="sr-only">Abrir menu</span>
                    Olá, {userProfile.name}!
                  </MenuButton>
                </div>
                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 ring-1 shadow-lg ring-black/5 transition focus:outline-hidden"
                >
                  <MenuItem>
                    <button
                      className="px-2 w-100 text-sm"
                      onClick={handleLogout}
                    >
                      Sair
                    </button>
                  </MenuItem>
                </MenuItems>
              </Menu>
              <button className="px-2 w-100 text-sm" onClick={handleLogout}>
                Sair
              </button>
            </div>
          </div>
        </div>
      </Disclosure>

      <div className="py-10">
        <header></header>
        <main>
          <div className="">
            <Switch>
              <Route path="/admin">
                <AdminDashboard />
              </Route>
              <Route path="/admin/conversas">
                <AdminConversas />
              </Route>
            </Switch>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Admin;
